export default {
  showSlide: 'Pokaż slajd {number} z {count}',
};
